import React from "react";
import { Link } from "react-router-dom";
import { MapPin, MessageSquareText, Phone } from "lucide-react";
import { PageBanner } from "@/components/site/PageBanner";

export default function Contact() {
  return (
    <>
    <PageBanner title="Contact Us" crumb="Contact" />
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10">
      <p className="eyebrow">Get in touch</p>
      <h2 className="mt-4 font-display text-3xl md:text-4xl">Let's plan your ride.</h2>
      <div className="gold-rule mt-8 w-40" />
      <div className="mt-16 grid gap-px overflow-hidden rounded-md border border-gold/25 bg-gold/25 md:grid-cols-3">
        <div className="bg-ink p-8" data-testid="contact-phone">
          <Phone className="text-gold" />
          <p className="mt-4 font-display text-xl">Call</p>
          <p className="mt-2 text-[15px] text-mist/80">[Phone number placeholder]</p>
        </div>
        <div className="bg-ink p-8" data-testid="contact-text">
          <MessageSquareText className="text-gold" />
          <p className="mt-4 font-display text-xl">Text</p>
          <p className="mt-2 text-[15px] text-mist/80">[Text number placeholder]</p>
        </div>
        <div className="bg-ink p-8" data-testid="contact-areas">
          <MapPin className="text-gold" />
          <p className="mt-4 font-display text-xl">Service areas</p>
          <p className="mt-2 text-[15px] text-mist/80">DeSoto County, Greater Memphis, Oxford and Nashville</p>
        </div>
      </div>
      <p className="mt-14 max-w-xl text-[15px] leading-relaxed text-mist/80">The fastest way to book is the request form. Kyia will text you a quote.</p>
      <Link to="/book" data-testid="contact-book-btn" className="mt-6 inline-flex min-h-[52px] items-center rounded-full bg-plum px-8 font-medium text-mist transition-colors duration-200 hover:bg-orchid">Book a Ride</Link>
    </div>
    </>
  );
}
